import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepBaggageAndPersonalItems = (state) => state.get('stepBaggageAndPersonalItems');

const makeSelectStepBaggageAndPersonalItems = () => createSelector(
  selectStepBaggageAndPersonalItems,
  (stepBaggageAndPersonalItemsState) => ({

    // Damaged Lost
    areYouClaimingForDamagedLostOrStolenLuggage: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'areYouClaimingForDamagedLostOrStolenLuggage']),
      ''
    ),
    areYouClaimingFor1: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'areYouClaimingFor1']),
      ''
    ),
    companyYouWereTravelingWith: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'companyYouWereTravelingWith']),
      ''
    ),
    areYouClaimingFor2: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'areYouClaimingFor2']),
      ''
    ),
    originForDamaged: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'originForDamaged']),
      ''
    ),
    flightNumberOriginForDamaged: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'flightNumberOriginForDamaged']),
      ''
    ),
    airCarrierOriginForDamaged: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'airCarrierOriginForDamaged']),
      ''
    ),
    destinationForDamaged: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'destinationForDamaged']),
      ''
    ),
    flightNumberDestinationForDamaged: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'flightNumberDestinationForDamaged']),
      ''
    ),
    airCarrierDestinationForDamaged: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'airCarrierDestinationForDamaged']),
      ''
    ),
    dateOfLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'dateOfLoss']),
      ''
    ),
    pleaseDescribeWhatOccurred: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'pleaseDescribeWhatOccurred']),
      ''
    ),
    areYouClaimingFor3: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'areYouClaimingFor3']),
      ''
    ),
    ifOtherPleaseDescribeWhere: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'ifOtherPleaseDescribeWhere']),
      ''
    ),
    whoDidYouReportTo: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'whoDidYouReportTo']),
      ''
    ),
    ifOtherPleaseDescribe2: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'ifOtherPleaseDescribe2']),
      ''
    ),
    reportReferenceNumber: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'reportReferenceNumber']),
      ''
    ),
    nameCustomerServiceDepartment: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'nameCustomerServiceDepartment']),
      ''
    ),
    address: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'postalCode']),
      ''
    ),
    phoneNumber: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'phoneNumber']),
      ''
    ),
    contact: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'contact']),
      ''
    ),
    doYouHaveAnyFurtherDetailsToAdd: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'doYouHaveAnyFurtherDetailsToAdd']),
      ''
    ),
    doYouHaveOtherTypeOfInsuranceBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'doYouHaveOtherTypeOfInsuranceBaggageLoss']),
      ''
    ),
    companyNameBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'companyNameBaggageLoss']),
      ''
    ),
    addressBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'addressBaggageLoss']),
      ''
    ),
    cityOrTownBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'cityOrTownBaggageLoss']),
      ''
    ),
    countryBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'countryBaggageLoss']),
      ''
    ),
    postalCodeBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'postalCodeBaggageLoss']),
      ''
    ),
    typeOfPolicyBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'typeOfPolicyBaggageLoss']),
      ''
    ),
    policyBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'policyBaggageLoss']),
      ''
    ),
    contactBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'contactBaggageLoss']),
      ''
    ),
    phoneBaggageLoss: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'phoneBaggageLoss']),
      ''
    ),

    // Baggage Delay
    areYouClaimingForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'areYouClaimingForBaggageDelay']),
      ''
    ),
    companyBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'companyBaggageDelay']),
      ''
    ),
    travelSupplierInformation: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'travelSupplierInformation']),
      ''
    ),
    originForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'originForBaggageDelay']),
      ''
    ),
    flightNumberOriginForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'flightNumberOriginForBaggageDelay']),
      ''
    ),
    airCarrierOriginForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'airCarrierOriginForBaggageDelay']),
      ''
    ),
    destinationForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'destinationForBaggageDelay']),
      ''
    ),
    flightNumberDestinationForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'flightNumberDestinationForBaggageDelay']),
      ''
    ),
    airCarrierDestinationForBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'airCarrierDestinationForBaggageDelay']),
      ''
    ),
    dateWhenYourLuggageWasDelayed: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'dateWhenYourLuggageWasDelayed']),
      ''
    ),
    timeWhenYourLuggageWasDelayed: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'timeWhenYourLuggageWasDelayed']),
      ''
    ),
    dateWhenYourLuggageWasReturned: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'dateWhenYourLuggageWasReturned']),
      ''
    ),
    timeWhenYourLuggageWasReturned: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'timeWhenYourLuggageWasReturned']),
      ''
    ),
    haveYouMadeAClaimWithYourTravelProvider: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'haveYouMadeAClaimWithYourTravelProvider']),
      ''
    ),
    doYouHaveOtherTypeOfInsuranceBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'doYouHaveOtherTypeOfInsuranceBaggageDelay']),
      ''
    ),
    companyNameBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'companyNameBaggageDelay']),
      ''
    ),
    addressBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'addressBaggageDelay']),
      ''
    ),
    cityOrTownBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'cityOrTownBaggageDelay']),
      ''
    ),
    countryBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'countryBaggageDelay']),
      ''
    ),
    postalCodeBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'postalCodeBaggageDelay']),
      ''
    ),
    typeOfPolicyBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'typeOfPolicyBaggageDelay']),
      ''
    ),
    policyBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'policyBaggageDelay']),
      ''
    ),
    contactBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'contactBaggageDelay']),
      ''
    ),
    phoneBaggageDelay: mapWithDefault(
      stepBaggageAndPersonalItemsState,
      () => stepBaggageAndPersonalItemsState.getIn(['form', 'phoneBaggageDelay']),
      ''
    ),
    descriptionOfItems: mapWithDefault(stepBaggageAndPersonalItemsState, () => stepBaggageAndPersonalItemsState.getIn(['form', 'descriptionOfItems']) && stepBaggageAndPersonalItemsState.getIn(['form', 'descriptionOfItems']).toJS(), ''),
    descriptionOfItemsForDamaged: mapWithDefault(stepBaggageAndPersonalItemsState, () => stepBaggageAndPersonalItemsState.getIn(['form', 'descriptionOfItemsForDamaged']) && stepBaggageAndPersonalItemsState.getIn(['form', 'descriptionOfItemsForDamaged']).toJS(), ''),
    //------------------------------------
  })
);

const makeSelectStepBaggageAndPersonalItemsErrors = () =>
  createSelector(selectStepBaggageAndPersonalItems, (state) => state.get('errors'));

export {
  makeSelectStepBaggageAndPersonalItems,
  makeSelectStepBaggageAndPersonalItemsErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepBaggageAndPersonalItems/selectors.js